import { render } from "./DashboardTab.vue?vue&type=template&id=7c66c33c"
import script from "./DashboardTab.vue?vue&type=script&lang=js"
export * from "./DashboardTab.vue?vue&type=script&lang=js"

import "./DashboardTab.vue?vue&type=style&index=0&id=7c66c33c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__